(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("accessibilityToolsService", AccessibilityToolsService);
    AccessibilityToolsService.$inject = [];

    function AccessibilityToolsService() {
        var self = this;
        var _accessibilityToolSettings;

        self.initAccessibilityTool = function (accessibilityToolSettings) {
            _accessibilityToolSettings = accessibilityToolSettings;
            if (accessibilityToolSettings.provider === 'RECITE_ME') {
                loadReciteMe(accessibilityToolSettings.client_key)
            }
        };

        self.showAccessibilityTool = function () {
            if (_accessibilityToolSettings.provider === 'RECITE_ME') {
                HStorageManager.put({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: 'Recite.Persist',
                    value: true,
                });
                Recite.load({});
            }
        };

        self.hideAccessibilityTool = function () {
            if(typeof Recite !== 'undefined'){
                Recite.disable(true);
            }
        };

        var loadReciteMe = function (clientKey) {
            var a = document.createElement("script");
            a.type = "text/javascript";
            a.src = "https://api.reciteme.com/asset/js?key=" + clientKey;
            if (a.readyState) {
                a.onreadystatechange = function () {
                    //Callback;
                    if ("loaded" === a.readyState || "complete" === a.readyState) {
                        a.onreadystatechange = null;
                        "function" === typeof _reciteLoaded && _reciteLoaded();
                        (HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'Recite.Persist'
                        }) == 'true') && Recite.load({});
                        Recite.Event.subscribe("Recite:load", function () {
                            Recite.enable();
                        });
                        Recite.Event.subscribe("Recite:disable", function () {
                            HStorageManager.put({
                                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                key: 'Recite.Persist',
                                value: false,
                            });
                        });
                    }
                };
            } else {
                a.onload = function () {
                    "function" === typeof _reciteLoaded && _reciteLoaded();
                        (HStorageManager.get({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'Recite.Persist'
                        })  == 'true') && Recite.load({});
                    Recite.Event.subscribe("Recite:load", function () {
                        Recite.enable();
                    });
                    Recite.Event.subscribe("Recite:disable", function () {
                        HStorageManager.put({
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                            key: 'Recite.Persist',
                            value: false,
                        });
                    });
                };
            }

            document.getElementsByTagName("head")[0].appendChild(a);
        };
    }
})();